
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.145 7.938C14.578 4.449 13.242 2 11.688 2 10.133 2 8.796 4.45 8.23 7.938h6.915zm-7.207 3.75c0 .867.046 1.699.128 2.5h7.239a24.493 24.493 0 000-5H8.066c-.082.8-.129 1.632-.129 2.5zm12.683-3.75a9.708 9.708 0 00-6.172-5.532c.953 1.32 1.61 3.309 1.953 5.531h4.22zm-11.7-5.532a9.701 9.701 0 00-6.167 5.531h4.219c.34-2.222.996-4.21 1.949-5.53zM21.04 9.187h-4.48c.082.82.128 1.66.128 2.5 0 .84-.046 1.68-.128 2.5h4.476c.215-.8.336-1.632.336-2.5 0-.867-.121-1.699-.332-2.5zm-14.352 2.5c0-.84.047-1.68.13-2.5H2.335C2.125 9.989 2 10.82 2 11.688c0 .868.125 1.7.336 2.5h4.476a26.45 26.45 0 01-.125-2.5zm1.543 3.75c.567 3.489 1.903 5.938 3.457 5.938 1.555 0 2.891-2.45 3.458-5.938H8.23zm6.223 5.532a9.717 9.717 0 006.172-5.532h-4.219c-.343 2.223-1 4.211-1.953 5.532zm-11.7-5.532a9.708 9.708 0 006.173 5.532c-.953-1.32-1.61-3.309-1.953-5.532h-4.22z","fill":"#282E3E"}})])
          )
        }
      }
    